import ErrorConnector from './error.props';
import ErrorComponent from './error.component';

export default ErrorConnector(ErrorComponent);
